import React from 'react'
import { TextField } from '@mui/material'

const getVariant = (variant) =>
  ({
    default: 'standard',
    border: 'outlined',
  }[variant])

/**
 * A custom input component for a text field, built on top of Material-UI's TextField.
 * It provides additional features like icon positioning and testId for testing purposes.
 *
 * @param {Object} props - The component's props.
 * @param {('default'|'border')} [props.variant] - The variant of the input field.
 * @param {('left'|'right')} [props.icon] - The position of the icon.
 * @param {React.ReactNode} [props.adornment] - The icon to be displayed in the input field.
 * @param {Object} [props.InputLabelProps] - Props to be passed to the InputLabel component.
 * @param {Object} [props.style] - The style object to be applied to the input field.
 * @param {string} [props.testId] - The data-testid attribute for testing purposes.
 * @param {Object} [rest] - Additional props to be spread onto the TextField component.
 *
 * @returns {React.ReactElement} - The InputText component.
 */
function InputText({ variant, icon, adornment, InputLabelProps, style, testId, ...rest }) {
  return (
    <TextField
      {...rest}
      style={style}
      InputLabelProps={InputLabelProps}
      variant={getVariant(variant) || 'standard'}
      InputProps={{
        startAdornment: icon === 'left' ? adornment : null,
        endAdornment: icon === 'right' ? adornment : null,
        inputProps: {
          'data-testid': testId,
        },
      }}
    />
  )
}

export default InputText
